import React, { useEffect, useState } from 'react';
import dayjs from 'utils/dayjs';
import { Box, Button, Flex } from '@spothero/ui';
import DateUtils from 'utils/date';
import CancellationInfo from 'common/cancellation-info';
import Card from 'common/card';
import PaymentMethodsIcons from 'common/payment-methods-icons';
import Price from 'common/price';
import AvailableInventory from '../available-inventory-message';
const AirportPurchaseInformation = ({ facility: { cancellation_allowed: cancellationAllowed }, starts, ends, selectedRate, availableTransientInventory, onCheckoutClick, displayPrice, currencyType, onShowConfirmDateTimeModal, onShowPriceBreakdownModal, isFetchingRates, }) => {
    const [prevIsFetchingRates, setPrevIsFetchingRates] = useState(isFetchingRates);
    const dateTimeFormatted = DateUtils.getDateTimeSummary({
        startDateTimeObj: dayjs(starts),
        endDateTimeObj: dayjs(ends),
        isMonthly: false,
    });
    const disableBookNow = !selectedRate || selectedRate?.unavailable;
    const handleOnClick = () => onShowConfirmDateTimeModal(true);
    useEffect(() => {
        if (prevIsFetchingRates && !isFetchingRates) {
            setPrevIsFetchingRates(isFetchingRates);
        }
    }, [isFetchingRates, prevIsFetchingRates]);
    return (<Card className="AirportPurchaseInformation">
            <div className="AirportPurchaseInformation-reservation-time">
                <div className="title">
                    <h2 className="title-heading">
                        <span>Reservation Time</span>
                    </h2>
                    <Button variant="tertiary" fontSize="sm" fontWeight="semibold" data-testid="AirportPurchaseInformation-change-button" onClick={handleOnClick}>
                        Change
                    </Button>
                </div>
                <div className="preview-datetime">{dateTimeFormatted}</div>
            </div>
            <AvailableInventory availableTransientInventory={availableTransientInventory}/>
            {!disableBookNow && (<div className="AirportPurchaseInformation-daily-price">
                    <span className="price-per-day">
                        <Flex alignItems="center" justifyContent="center">
                            <Price amount={displayPrice} currencyType={currencyType}/>
                            {'  '}
                            <Button variant="tertiary" onClick={onShowPriceBreakdownModal} paddingLeft={1} fontSize="md" fontWeight="normal" color="black" textDecoration="underline" data-testid="AirportPurchaseInformation-total-price">
                                <span className="per-day">Total</span>
                            </Button>
                        </Flex>
                    </span>
                </div>)}
            <Button width="100%" marginBottom={4} variant="primary" isDisabled={disableBookNow} onClick={onCheckoutClick}>
                Book Now
            </Button>
            <PaymentMethodsIcons showAlternatePaymentOptions alignment="center"/>
            <Box textAlign="center" marginTop={2}>
                <CancellationInfo cancellationAllowed={cancellationAllowed}/>
            </Box>
        </Card>);
};
export default AirportPurchaseInformation;
